import {
	AdminEarningsService,
	IEarningWarningsResponse,
} from "../../services/AdminEarningsService";
import { Box, Grid, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { Button } from "primereact/button";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { IAdminEarnings } from "../../models/AdminEarnings";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { PayrollEarningsDataGrid } from "./PayrollEarningsDataGrid";
import { PrimeDataGrid } from "../PrimeDataGrid";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useNavigateToLogout } from "../../common/Common";

export interface IAdminEarningsList { }
const CLIENT_LIST_QUERY_KEY = "adminEarnings-list";

const useAdminEarningses = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["adminEarnings-list", params],
		queryFn: (data) => {
			return AdminEarningsService.getAdminEarnings(params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

export const AdminEarningsList: React.FC<IAdminEarningsList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "adminEarningName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useAdminEarningses(queryParams, navigateToLogout); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const adminEarningsList: any | null = data;

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [openWarningStatusDialog, setOpenWarningStatusDialog] = useState(false);
	const [warningStatusDialogData, setWarningStatusDialogData] =
		useState<any>(undefined);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroAdminEarnings, setzeroAdminEarnings] = useState(true);
	const [adminEarningsListUpdatedItems, setAdminEarningsListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [adminEarningsId, setAdminEarningsId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkAdminEarningsId, setBulkAdminEarningsId] = useState<any>({});
	const [bulkAdminEarningsDelete, setBulkAdminEarningsDelete] =
		useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "adminEarningName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};
		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroAdminEarnings(false);
	};

	const onRowEditClicked = useCallback((params: IAdminEarnings) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/payroll-earning/setup/${params.id}`;
		navigate(path);
	}, []);

	const onWarningStatusButtonClicked = useCallback((params: IAdminEarnings) => {
		(async () => {
			try {
				const response: IEarningWarningsResponse | IServerError | IResponse =
					await AdminEarningsService.getEarningWarnings(
						params.id,
						navigateToLogout
					);
				if ("messages" in response && Array.isArray(response.messages)) {
					setWarningStatusDialogData(response?.messages);
					setOpenWarningStatusDialog(true);
				}
			} catch { }
		})();
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onCloseWarningStatusDialogueHandler = () => {
		setOpenWarningStatusDialog(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteAdminEarningsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				adminEarningsId: adminEarningsId,
				navigateToLogout: navigateToLogout,
			};
			deleteAdminEarningsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: IAdminEarnings) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setAdminEarningsId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteAdminEarningsById } =
		useMutation({
			mutationFn: AdminEarningsService.delAdminEarnings,

			onSuccess: (res: string | IServerError | IResponse | any) => {
				if (typeof res === "string") {
					// remove the cache of the Employee fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				return queryClient.invalidateQueries({
					queryKey: [CLIENT_LIST_QUERY_KEY],
				});
			},
			onError: (err) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	// dispatch(setSelectedAdminEarnings(clickedRow));
	// dispatch(setSelectedAdminEarningsName(clickedRow));
	// };

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkAdminEarningses } =
		useMutation({
			mutationFn: AdminEarningsService.delBulkAdminEarningses,
			onSuccess: (res: any | string | IServerError | IResponse) => {
				if (typeof res === "object") {
					// remove the cache of the Year fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong.",
						severity: res.status === false ? "error" : "success",
					});

					setBulkAdminEarningsDelete(false);
					return queryClient.invalidateQueries({
						queryKey: [CLIENT_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				setBulkAdminEarningsDelete(false);
			},
			onError: (err: any) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
				setBulkAdminEarningsDelete(false);
			},
		});

	// For Bulk Delete
	const deleteBulkAdminEarningsField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				adminEarningsIds: bulkAdminEarningsId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkAdminEarningses(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {
		let bulkDeletePayload = {
			adminEarningsIds: { adminEarningsIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkAdminEarningsId(bulkDeletePayload);
		setBulkAdminEarningsDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);
		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					{/* <Button
						onClick={() => onRowMultipleDeleteClicked(selectedItems)}
						variant="contained"
						color="error"
					>
						Delete
					</Button> */}
				</Box>
			);
		}
		return <></>;
	}, []);

	const upadtedAdminEarningsListItems = useMemo(() => {
		return (
			adminEarningsList &&
			adminEarningsList.items &&
			adminEarningsList?.items.map((item: any) => ({
				...item,
				// title: (
				// 	<Link
				// 		to={`/company/adminEarnings/setup/${item.id}`}
				// 		className="no-underline"
				// 		style={{ color: theme.palette.primary.light }}
				// 	>
				// 		{item.title}
				// 	</Link>
				// ),
			}))
		);
	}, [adminEarningsList]);

	const expandedLabels = ["Earnings", "Payroll Earnings"];
	const expandedAdminEarningsListOrSetupItem = "List"; // Special case for "List" under "AdminEarnings"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Payroll Earnings" &&
				item.label === expandedAdminEarningsListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "Payroll Earnings" && item.label === expandedAdminEarningsListOrSetupItem && "/payroll-earning/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return adminEarningsList &&
		adminEarningsList.items &&
		adminEarningsList.items.length === 0 &&
		zeroAdminEarnings === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Payroll Earnings to proceed`}
			content={`You can add Payroll Earnings by directly clicking on add Payroll Earnings button.`}
			testId={"adminEarnings-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Payroll Earnings"}
			navigateToAdd={"/payroll-earning/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkAdminEarningsDelete === true
							? deleteBulkAdminEarningsField
							: deleteAdminEarningsField
					}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<PayrollEarningsDataGrid
					columns={adminEarningsList ? adminEarningsList.headerColumns : []}
					rows={
						adminEarningsList && upadtedAdminEarningsListItems
							? upadtedAdminEarningsListItems
							: []
					}
					showIndexColumn={false}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						adminEarningsList && adminEarningsList.total
							? adminEarningsList.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by AdminEarnings Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroAdminEarnings(value)
					}
					pageTitle="Payroll Earnings"
					onWarningStatusButtonClicked={onWarningStatusButtonClicked}
				/>
			</Grid>

			{/* Warning Status Dialogue */}
			<EnhancedDialog
				dialogTitle="Earnings missing information"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseWarningStatusDialogueHandler}
				open={openWarningStatusDialog}
				dialogContent={
					<ul
						style={{
							listStyleType: "none",
							paddingLeft: 0,
							fontSize: "0.875rem",
						}}
					>
						{warningStatusDialogData?.length > 0 ? (
							warningStatusDialogData.map((x: any, i: number) => (
								<li key={i} className="mb-2">
									{x.text}{" "}
									<Link
										to={x.route}
										className="no-underline"
										style={{ color: theme.palette.primary.light }}
									>
										<Button
											label={x.keyword}
											style={{
												padding: "0.2rem",
												fontSize: ".75rem",
												borderRadius: "2px",
												boxShadow: "none",
												outline: "none",
											}}
										/>
									</Link>{" "}
									configurations
								</li>
							))
						) : (
							<li>No warnings to display.</li>
						)}
					</ul>
				}
				showdividers={false}
				// dialogMaxWidth={700}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							// text
							raised
							onClickHandler={onCloseWarningStatusDialogueHandler}
							style={{ fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
